module.exports = __webpack_public_path__ + "img/sabah.d6073570.png";